import { Logger, engineComponent } from "neo-common";
import { Song } from "./Song";
import { ComponentTypes } from "../ComponentTypes";
import { SoundManager } from "../Managers/SoundManager";

@engineComponent(ComponentTypes.PlayList)
export class PlayList {
    static Songs: { [id: string]: Song } = {};

    static addToPlayList(song: Song): void {
        PlayList.Songs[song.id] = song;
    }

    create(node: Element): void {
        SoundManager.parseElements(node, node.nodeName);
    }

    static play(song: string, fadeIn: number = 0, reset: boolean = true): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(false, fadeIn, reset);
        }
    }

    static loop(song: string, fadeIn: number = 0, reset: boolean = false): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].play(true, fadeIn, reset);
        }
    }

    static stop(song: string, fadeOut: number = 0): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].stop(fadeOut);
        }
    }

    static stopAll(fadeOut: number = 0): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].stop(fadeOut);
            }
        }
    }

    static stopAllInGroup(group: string, toggle: boolean = false): void {
        if (PlayList.Songs != null) {
            for (let song in PlayList.Songs) {
                PlayList.Songs[song].toggleGroup(group, toggle);
            }
        }
    }

    static log(s: string): void {
        if (DEBUG) {
            const compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }

    //******************************************************************************************************************
    //  IT'S SPECIAL...
    //******************************************************************************************************************

    static setVolume(song: string, volume: number): void {
        if (PlayList.Songs[song] != null) {
            PlayList.Songs[song].setVolume(volume);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Components/Sounds/PlayList.ts
 **/